import { get } from 'lodash-es';

export const transformTmvConditions = data => ({
  tmvConditions: get(data, 'tmvconditions'),
  responseId: get(data, 'responseId'),
});
